var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.9 14.9",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#304256",
    d: "M.2 7.9L7 14.7c.2.2 0 .3.3.2.3-.1-.1-.4-.1-.7V9.8H21c1 0 1.9-1 1.9-2s-.8-2-1.9-2H7.2V.7c0-.3.3-.5.1-.7h-.1C7 0 7 .1 6.8.2L.2 6.9c-.3.3-.2.8 0 1z"
  })));
}

export default SvgArrowRight;